import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App";
import { initAnalytics } from "@/shared/analytics/analytics";
import { initErrorTracking } from "@/shared/errors/errorTracking";
import "@/styles/global.css";
import "@/styles/ui.css";
import "@/styles/features.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

initAnalytics();
initErrorTracking();
